import { useState } from 'react';
import {
  getPaises,
  getAduanas,
  getModosTransporteFronteraPredefinidos,
  getMediosTransporteFrontera,
  getExportacionesTipos,
  getTipoUbicacionOptions,
  getDivisasISO,
  getCondicionesEntrega,
  getClavesDeclarante,
} from '../../../utils/modalDataUtils';

// Simple text display component
const TextDisplay = ({ value, className = "" }) => {
  const displayValue = value === null || value === undefined || value === '' ? 'null' : value;
  return (
    <p className={`${className} py-1`}>{displayValue}</p>
  );
};

export const DeclarationInformation = ({
  handleChange,
  declarationIndex,
  isSpanish,
  declaration,
}) => {
  const [activeTab, setActiveTab] = useState("All");

  // find the selected country objects for display
  const paises = getPaises();
  const selectedPaisDestino = paises.find(
    (p) =>
      p.codigo === declaration.pais_destino ||
      p.nombre === declaration.pais_destino
  );
  const selectedPaisExportacion = paises.find(
    (p) =>
      p.codigo === declaration.pais_exportacion ||
      p.nombre === declaration.pais_exportacion
  );
  const selectedPaisTransporteFrontera = paises.find(
    (p) =>
      p.codigo === declaration.pais_transporte_frontera ||
      p.nombre === declaration.pais_transporte_frontera
  );
  const selectedPaisUbicacion = paises.find(
    (p) =>
      p.codigo === declaration.pais_ubicacion ||
      p.nombre === declaration.pais_ubicacion
  );

  // find the selected aduana objects for display
  const aduanasEntrada = getAduanas('aduanas-espanolas');
  const aduanasSalida = getAduanas(['aduanas-comunitarias-espanolas', 'aduanas-comunitarias-no-espanolas']);
  const aduanasDespacho = getAduanas('aduanas-espanolas');
  
  const selectedAduanaEntrada = aduanasEntrada.find(
    (a) =>
      a.codigo === declaration.aduana_entrada ||
      a.nombre === declaration.aduana_entrada
  );
  const selectedAduanaSalida = aduanasSalida.find(
    (a) =>
      a.codigo === declaration.aduana_salida ||
      a.nombre === declaration.aduana_salida
  );
  const selectedAduanaDespacho = aduanasDespacho.find(
    (a) =>
      a.codigo === declaration.aduana_despacho ||
      a.nombre === declaration.aduana_despacho
  );

  // find the selected modo objects for display
  const modosTransporteFronteraPredefinidos = getModosTransporteFronteraPredefinidos();
  const selectedModoFrontera = modosTransporteFronteraPredefinidos.find(
    (m) =>
      m.codigo === declaration.modo_transporte_frontera ||
      m.nombre === declaration.modo_transporte_frontera
  );

  // find the selected medio objects for display
  const mediosTransporteFrontera = getMediosTransporteFrontera();
  const selectedMedioTransporteFrontera = mediosTransporteFrontera.find(
    (m) =>
      m.codigo === declaration.medio_transporte_frontera ||
      m.nombre === declaration.medio_transporte_frontera
  );

  // find the selected export type for display
  const exportacionesTipos = getExportacionesTipos();
  const selectedExportacionesTipo = exportacionesTipos.find(
    (t) => t.codigo === declaration.tipo || t.nombre === declaration.tipo
  );

  // find the selected tipo ubicacion for display
  const tipoUbicacionOptions = getTipoUbicacionOptions();
  const selectedTipoUbicacion = tipoUbicacionOptions.find(
    (t) =>
      t.codigo === declaration.tipo_ubicacion ||
      t.nombre === declaration.tipo_ubicacion
  );

  const divisas = getDivisasISO();
  const selectedDivisa = divisas.find(
    (d) => d.iso === declaration.divisa || d.codigo === declaration.divisa
  );
  const selectedDivisaIso = divisas.find(
    (d) =>
      d.iso === declaration.divisa_iso || d.codigo === declaration.divisa_iso
  );

  // find the selected clave declarante for display
  const clavesDeclarante = getClavesDeclarante();
  const selectedClaveDeclarante = clavesDeclarante.find(
    (c) =>
      c.codigo === declaration.clave_declarante ||
      c.nombre === declaration.clave_declarante
  );

  // Tab definitions
  const tabs = [
    { id: "All", label: !isSpanish ? "All" : "Todo" },
    { id: "Expediente", label: !isSpanish ? "Expediente" : "Expediente" },
    { id: "Declaración", label: !isSpanish ? "Declaración" : "Declaración" },
    { id: "Datos Transporte", label: !isSpanish ? "Datos Transporte" : "Datos Transporte" },
    { id: "Información Adicional", label: !isSpanish ? "Información Adicional" : "Información Adicional" },
    { id: "Importes", label: !isSpanish ? "Importes" : "Importes" },
  ];

  return (
    <>
      {/* Tab Navigation */}
      <div className="pt-2 mt-4 overflow-x-auto mb-4">
        <div className="flex gap-2 items-center pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`h-10 rounded-full text-sm cursor-pointer hover:opacity-75 transition-opacity py-1 whitespace-nowrap flex-shrink-0 ${
                activeTab === tab.id
                  ? 'bg-secondary font-semibold px-4'
                  : 'px-2'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="grid grid-cols-2 gap-8 rounded-md">
        {/* EXPEDIENTE TAB */}
        {(activeTab === "All" || activeTab === "Expediente") && (
          <>
            {/* Declaration Type & Date */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish
                  ? "Declaration Type and Date"
                  : "Tipo y Fecha de Declaración"}
              </h2>
              <div className={`form-group flex-1`}>
                <label
                  htmlFor="tipo"
                  className={`${!declaration.tipo && "text-red-600"}`}
                >
                  {!isSpanish ? "Type" : "Tipo"}
                </label>
                <TextDisplay
                  value={selectedExportacionesTipo 
                    ? `${selectedExportacionesTipo.codigo}${selectedExportacionesTipo.nombre ? ` (${selectedExportacionesTipo.nombre})` : ''}`
                    : declaration.tipo
                  }
                />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="fecha_registro"
                >
                  {!isSpanish ? "Registration Date" : "Fecha Registro"}
                </label>
                <TextDisplay value={declaration.fecha_registro} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="fecha_creacion"
                >
                  {!isSpanish ? "Creation Date" : "Fecha Creación"}
                </label>
                <TextDisplay value={declaration.fecha_creacion} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="fecha_operacion"
                >
                  {!isSpanish ? "Operation Date" : "Fecha Operación"}
                </label>
                <TextDisplay value={declaration.fecha_operacion} />
              </div>
            </div>

            {/* Declaration Identification */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish
                  ? "Declaration Identification"
                  : "Identificación de la Declaración"}
              </h2>
              <div className="form-group flex-1">
                <label
                  htmlFor="mrn"
                  className={`${!declaration.mrn && "text-red-600"}`}
                >
                  {!isSpanish ? "MRN" : "MRN (Número de Referencia del Movimiento)"}
                </label>
                <TextDisplay value={declaration.mrn} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="declaracion_1"
                >
                  {!isSpanish ? "Declaration 1" : "Declaración 1"}
                </label>
                <TextDisplay value={declaration.declaracion_1} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="declaracion_2"
                >
                  {!isSpanish ? "Declaration 2" : "Declaración 2"}
                </label>
                <TextDisplay value={declaration.declaracion_2} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="declaracion_3"
                >
                  {!isSpanish ? "Declaration 3" : "Declaración 3"}
                </label>
                <TextDisplay value={declaration.declaracion_3} />
              </div>
            </div>

            {/* Operators/Parties References */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Operators Information" : "Información de Operadores"}
              </h2>
              <div className="form-group">
                <label
                  htmlFor="cliente_id"
                  className={`${!declaration.cliente_id && "text-red-600"}`}
                >
                  {!isSpanish ? "Client ID" : "Cliente ID"}
                </label>
                <TextDisplay value={declaration.cliente_id} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="remitente_id"
                  className={`${!declaration.remitente_id && "text-red-600"}`}
                >
                  {!isSpanish ? "Sender ID" : "Remitente ID"}
                </label>
                <TextDisplay value={declaration.remitente_id} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="clave_declarante"
                >
                  {!isSpanish ? "Declarant Key" : "Clave Declarante"}
                </label>
                <TextDisplay
                  value={selectedClaveDeclarante
                    ? `${selectedClaveDeclarante.codigo}${selectedClaveDeclarante.nombre ? ` (${selectedClaveDeclarante.nombre})` : ''}`
                    : declaration.clave_declarante
                  }
                />
              </div>
            </div>

            {/* Packages */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Packaging Information" : "Información de Embalaje"}
              </h2>
              <div className="form-group">
                <label
                  htmlFor="tiene_contenedores"
                >
                  {!isSpanish ? "Has Containers" : "Tiene Contenedores"}
                </label>
                <TextDisplay value={declaration.tiene_contenedores} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="total_bultos"
                >
                  {!isSpanish ? "Total Packages" : "Total Bultos"}
                </label>
                <TextDisplay value={declaration.total_bultos} />
              </div>
            </div>
          </>
        )}

        {/* DECLARACIÓN TAB */}
        {(activeTab === "All" || activeTab === "Declaración") && (
          <>
            {/* Customs Information */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Customs Information" : "Información Aduanera"}
              </h2>
              <div className="form-group">
                <label
                  htmlFor="aduana_entrada"
                >
                  {!isSpanish ? "Entry Customs" : "Aduana Entrada"}
                </label>
                <TextDisplay
                  value={selectedAduanaEntrada
                    ? `${selectedAduanaEntrada.codigo}${selectedAduanaEntrada.nombre ? ` (${selectedAduanaEntrada.nombre})` : ''}`
                    : declaration.aduana_entrada
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="aduana_salida"
                >
                  {!isSpanish ? "Exit Customs" : "Aduana Salida"}
                </label>
                <TextDisplay
                  value={selectedAduanaSalida
                    ? `${selectedAduanaSalida.codigo}${selectedAduanaSalida.nombre ? ` (${selectedAduanaSalida.nombre})` : ''}`
                    : declaration.aduana_salida
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="aduana_despacho"
                >
                  {!isSpanish ? "Clearance Customs" : "Aduana Despacho"}
                </label>
                <TextDisplay
                  value={selectedAduanaDespacho
                    ? `${selectedAduanaDespacho.codigo}${selectedAduanaDespacho.nombre ? ` (${selectedAduanaDespacho.nombre})` : ''}`
                    : declaration.aduana_despacho
                  }
                />
              </div>
            </div>
          </>
        )}

        {/* DATOS TRANSPORTE TAB */}
        {(activeTab === "All" || activeTab === "Datos Transporte") && (
          <>
            {/* Transport */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Transport Details" : "Detalles de Transporte"}
              </h2>
              <div className="form-group">
                <label
                  htmlFor="modo_transporte_frontera"
                >
                  {!isSpanish
                    ? "Border Transport Mode"
                    : "Modo Transporte Frontera"}
                </label>
                <TextDisplay
                  value={selectedModoFrontera
                    ? `${selectedModoFrontera.codigo}${selectedModoFrontera.nombre ? ` (${selectedModoFrontera.nombre})` : ''}`
                    : declaration.modo_transporte_frontera
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="modo_transporte_interior"
                >
                  {!isSpanish
                    ? "Internal Transport Mode"
                    : "Modo Transporte Interior"}
                </label>
                <TextDisplay value={declaration.modo_transporte_interior} />
              </div>
              <div className="form-group flex-1">
                <label
                  htmlFor="identidad_transporte_frontera"
                >
                  {!isSpanish
                    ? "Border Transport Identity"
                    : "Identidad Transporte Frontera"}
                </label>
                <TextDisplay value={declaration.identidad_transporte_frontera} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="medio_transporte_frontera"
                >
                  {!isSpanish
                    ? "Transport Means (Border)"
                    : "Medio Transporte Frontera"}
                </label>
                <TextDisplay
                  value={selectedMedioTransporteFrontera
                    ? `${selectedMedioTransporteFrontera.codigo}${selectedMedioTransporteFrontera.nombre ? ` (${selectedMedioTransporteFrontera.nombre})` : ''}`
                    : declaration.medio_transporte_frontera
                  }
                />
              </div>
            </div>
          </>
        )}

        {/* INFORMACIÓN ADICIONAL TAB */}
        {(activeTab === "All" || activeTab === "Información Adicional") && (
          <>
            {/* EDI Status */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "EDI Status" : "Estado EDI"}
              </h2>
              <div className="form-group">
                <label htmlFor="autorizacion_por_operacion">
                  {!isSpanish
                    ? "Authorization per Operation (0/1)"
                    : "Autorización por Operación (0/1)"}
                </label>
                <TextDisplay value={declaration.autorizacion_por_operacion} />
              </div>
              <div className="form-group">
                <label htmlFor="flag_datos_seguridad">
                  {!isSpanish
                    ? "Security Data (0/1)"
                    : "Datos de Seguridad (0/1)"}
                </label>
                <TextDisplay value={declaration.flag_datos_seguridad} />
              </div>
              <div className="form-group">
                <label htmlFor="es_simplificado">
                  {!isSpanish ? "Simplified (0/1)" : "Simplificado (0/1)"}
                </label>
                <TextDisplay value={declaration.es_simplificado} />
              </div>
              <div className="form-group">
                <label htmlFor="es_recapitulativo">
                  {!isSpanish ? "Recapitulative (0/1)" : "Recapitulativo (0/1)"}
                </label>
                <TextDisplay value={declaration.es_recapitulativo} />
              </div>
              <div className="form-group">
                <label htmlFor="estado_pdc">
                  {!isSpanish ? "PDC Status" : "Estado PDC"}
                </label>
                <TextDisplay value={declaration.estado_pdc} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="estado_edi"
                >
                  {!isSpanish ? "EDI Status" : "Estado EDI"}
                </label>
                <TextDisplay value={declaration.estado_edi} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="estado_edi_canarias"
                >
                  {!isSpanish ? "Canary Islands EDI Status" : "Estado EDI Canarias"}
                </label>
                <TextDisplay value={declaration.estado_edi_canarias} />
              </div>
            </div>
            {/* Other Information */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Additional Information" : "Información Adicional"}
              </h2>
              <div className="grid grid-cols-2 gap-4">
                <div className="form-group">
                  <label htmlFor={`completo_${declarationIndex + 1}`}>
                    {!isSpanish ? "Complete (0/1)" : "Completo (0/1)"}
                  </label>
                  <TextDisplay value={declaration.completo} />
                </div>
                <div className="form-group">
                  <label htmlFor={`es_plantilla_${declarationIndex + 1}`}>
                    {!isSpanish ? "Is Template (0/1)" : "¿Es Plantilla (0/1)?"}
                  </label>
                  <TextDisplay value={declaration.es_plantilla} />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="form-group">
                  <label htmlFor="e_mail">
                    {!isSpanish
                      ? "Contact Email"
                      : "Correo Electrónico de Contacto"}
                  </label>
                  <TextDisplay value={declaration.e_mail} />
                </div>
                <div className="form-group">
                  <label htmlFor="contacto_telefono">
                    {!isSpanish ? "Contact Phone" : "Teléfono de Contacto"}
                  </label>
                  <TextDisplay value={declaration.contacto_telefono} />
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="naturaleza_transaccion"
                >
                  {!isSpanish ? "Transaction Nature" : "Naturaleza Transacción"}
                </label>
                <TextDisplay value={declaration.naturaleza_transaccion} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="observaciones"
                >
                  {!isSpanish ? "Observations" : "Observaciones"}
                </label>
                <TextDisplay value={declaration.observaciones} />
              </div>
            </div>
          </>
        )}

        {/* IMPORTES TAB */}
        {(activeTab === "All" || activeTab === "Importes") && (
          <>
            {/* Invoice Information */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Invoice Details" : "Detalles de Factura"}
              </h2>
              <div className="form-group">
                <label htmlFor="divisa">
                  {!isSpanish
                    ? "Currency Code (numeric)"
                    : "Código Divisa (numérico)"}
                </label>
                <TextDisplay
                  value={selectedDivisa
                    ? `${selectedDivisa.codigo}${selectedDivisa.descripcion ? ` (${selectedDivisa.descripcion})` : ''}`
                    : declaration.divisa
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="cambio_divisa">
                  {!isSpanish ? "Exchange Rate" : "Cambio Divisa"}
                </label>
                <TextDisplay value={declaration.cambio_divisa} />
              </div>
              <div className="form-group">
                <label htmlFor="divisa_iso">
                  {!isSpanish ? "Currency ISO (3-letter)" : "Divisa ISO (3 letras)"}
                </label>
                <TextDisplay
                  value={selectedDivisaIso
                    ? `${selectedDivisaIso.iso}${selectedDivisaIso.descripcion ? ` (${selectedDivisaIso.descripcion})` : ''}`
                    : declaration.divisa_iso
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="factura"
                >
                  {!isSpanish ? "Invoice" : "Factura"}
                </label>
                <TextDisplay value={declaration.factura} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="fecha_factura"
                >
                  {!isSpanish ? "Invoice Date" : "Fecha Factura"}
                </label>
                <TextDisplay value={declaration.fecha_factura} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="condiciones_entrega"
                >
                  {!isSpanish ? "Delivery Terms" : "Condiciones Entrega"}
                </label>
                <TextDisplay
                  value={(() => {
                    const condiciones = getCondicionesEntrega();
                    const selectedCondicion = condiciones.find(
                      (c) => c.codigo === declaration.condiciones_entrega
                    );
                    if (selectedCondicion) {
                      return `${selectedCondicion.codigo}${selectedCondicion.nombre ? ` (${selectedCondicion.nombre})` : ''}`;
                    }
                    return declaration.condiciones_entrega;
                  })()}
                />
              </div>
            </div>
            {/* Countries */}
            <div className="split-modal flex flex-col gap-4 rounded-md flex-1">
              <h2 className="text-sm text-gray-500 font-bold">
                {!isSpanish ? "Country Information" : "Información de Países"}
              </h2>
              <div className="form-group">
                <label htmlFor="pais_ubicacion">
                  {!isSpanish
                    ? "Location Country (2-letter ISO)"
                    : "País Ubicación (ISO 2 letras)"}
                </label>
                <TextDisplay
                  value={selectedPaisUbicacion
                    ? `${selectedPaisUbicacion.codigo}${selectedPaisUbicacion.nombre ? ` (${selectedPaisUbicacion.nombre})` : ''}`
                    : declaration.pais_ubicacion
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="tipo_ubicacion">
                  {!isSpanish
                    ? "Location Type (A/B/C/D)"
                    : "Tipo Ubicación (A/B/C/D)"}
                </label>
                <TextDisplay
                  value={selectedTipoUbicacion
                    ? `${selectedTipoUbicacion.codigo}${selectedTipoUbicacion.nombre ? ` (${selectedTipoUbicacion.nombre})` : ''}`
                    : declaration.tipo_ubicacion
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="localizacion">
                  {!isSpanish ? "Location Code" : "Código de Localización"}
                </label>
                <TextDisplay value={declaration.localizacion} />
              </div>
              <div className="form-group">
                <label htmlFor="codigo_un">
                  {!isSpanish ? "UN Code (Delivery Place)" : "Código UN (Lugar Entrega)"}
                </label>
                <TextDisplay value={declaration.codigo_un} />
              </div>
              <div className="form-group">
                <label htmlFor="lugar_entrega">
                  {!isSpanish ? "Delivery Place" : "Lugar Entrega"}
                </label>
                <TextDisplay value={declaration.lugar_entrega} />
              </div>
              <div className="form-group">
                <label htmlFor="tipo_autorizacion_cd">
                  {!isSpanish
                    ? "Type (49 Autorización C.D.)"
                    : "Tipo (49 Autorización C.D.)"}
                </label>
                <TextDisplay value={declaration.tipo_autorizacion_cd} />
              </div>
              <div className="form-group">
                <label htmlFor="identificacion_adicional">
                  {!isSpanish
                    ? "Additional Identification"
                    : "Identificación Adicional"}
                </label>
                <TextDisplay value={declaration.identificacion_adicional} />
              </div>
              <div className="form-group">
                <label
                  htmlFor="pais_destino"
                >
                  {!isSpanish ? "Destination Country" : "País Destino"}
                </label>
                <TextDisplay
                  value={selectedPaisDestino
                    ? `${selectedPaisDestino.codigo}${selectedPaisDestino.nombre ? ` (${selectedPaisDestino.nombre})` : ''}`
                    : declaration.pais_destino
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="pais_exportacion"
                >
                  {!isSpanish ? "Export Country" : "País Exportación"}
                </label>
                <TextDisplay
                  value={selectedPaisExportacion
                    ? `${selectedPaisExportacion.codigo}${selectedPaisExportacion.nombre ? ` (${selectedPaisExportacion.nombre})` : ''}`
                    : declaration.pais_exportacion
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="pais_transporte_frontera"
                >
                  {!isSpanish
                    ? "Border Transport Country"
                    : "País Transporte Frontera"}
                </label>
                <TextDisplay
                  value={selectedPaisTransporteFrontera
                    ? `${selectedPaisTransporteFrontera.codigo}${selectedPaisTransporteFrontera.nombre ? ` (${selectedPaisTransporteFrontera.nombre})` : ''}`
                    : declaration.pais_transporte_frontera
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
